export default `
    <div id="#= data.id #_Container" class="nav-bar-tab-container">
        <span class="nav-bar-tab">
            <span class="skewbackground">
                <div class="unskew topBotomBordersIn">
                    <a id="#= data.id #" class="banner-link #= data.routerLink #" href="#= data.href #">#= data.text #</a>
                </div>
            </span>
        </span>
        <span class="nav-bar-seperator">/</span>
    </div>
`;
